import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import ClaimAppealPageComponent from './ClaimAppealPage';
import { getClaimAllDetails,get,getClaimJSONView, getClaimPayerInfo, generateClaimForm} from '../../store/actions/claimAnalysis';
import {  } from '../../store/api/claimAnalysis';
import { RootState } from '../../store/reducers';


const selectClaimNumber = (props) => props.match.params.claimNumber;
const selectClaimId = (props) => props.match.params.claimId;
const selectData = (state) => state?.claimAnalysis?.jsonView;
export const ClaimAppealPage = connect(
    (state: RootState ,props) => {    
        return {
            claimData: selectData(state),                           
            claimNumber:selectClaimNumber(props),
            claimId:selectClaimId (props),
            isPayerInfoLoading: state?.claimAnalysis?.getClaimPayerInfo?.pending,
            isGeneratingForm: state?.claimAnalysis?.generateClaimForm?.pending,    
        };  
    },
    (dispatch) => ({
        actions: bindActionCreators({
            getClaimAllDetails: getClaimAllDetails,
            get:get,
            getClaimData:getClaimJSONView,
            getClaimPayerInfo,
            generateClaimForm
        }, dispatch)
    })
)(injectIntl(ClaimAppealPageComponent));